import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "./Icon";
/**
 * UploadIcon - An upload icon with upward arrow and horizontal line
 */
export const UploadIcon = ({ size = 16, color = "currentColor", className = "", ...props }) => {
    return (_jsxs(Icon, { size: size, color: color, viewBox: "0 0 16 16", className: className, ...props, children: [_jsx("path", { d: "M8 11V3M8 3L5 6M8 3L11 6", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M2 11V12C2 12.5304 2.21071 13.0391 2.58579 13.4142C2.96086 13.7893 3.46957 14 4 14H12C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12V11", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
};
